import { createFileRoute, redirect } from '@tanstack/react-router'

import { ProductDetailPage } from '../../../../components/pages/backoffice/home/product-detail-page.tsx'
import { findDisplayableProductGroup } from '../../../../components/pages/backoffice/home/product-detail-page.utils.ts'
import { logger } from '../../../../lib/logger.ts'

export const Route = createFileRoute('/bo/products/$productGroupSlug/')({
  loader: async ({ context, params }) => {
    const productGroups = await context.queryClient.ensureQueryData(
      context.trpc.productPresentation.getProductPresentations.queryOptions(),
    )
    const productGroup = findDisplayableProductGroup(productGroups, params.productGroupSlug)
    if (!productGroup) {
      logger.warning('Product group not found', { productGroupSlug: params.productGroupSlug })
      throw redirect({ to: '/bo/products', replace: true })
    }
    return { productGroup }
  },
  component: function Component() {
    const { productGroup } = Route.useLoaderData()
    return <ProductDetailPage productGroup={productGroup} />
  },
})
